import Header from "../components/landing/Header";
import HowItWorks from "../components/landing/HowItWorks";
import CTASection from "../components/landing/CTASection";
import Footer from "../components/landing/Footer";

export default function HowItWorksPage() {
  return (
    <main data-testid="how-it-works-page" className="relative">
      <Header />
      <HowItWorks />
      <CTASection />
      <Footer />
    </main>
  );
}
